import Api from "./Api"
import { API_VERSION } from "@/config/index"

export default {
    GetAllMovies(payload) {
        let query = "";
        if (Object.keys(payload).length > 0) {
            let urlparams = new URLSearchParams();
            for(const key in payload) {
                if(payload[key]) {
                    urlparams.append(key, payload[key]);
                }
            }
            if([...urlparams.entries()].length > 0) {
                query += `?${urlparams.toString()}`;
            }
            // query += `?search=${payload.search}`;
        }
        return Api().get(`/admin/movie/${query}`, payload)
        // return Api().get(`/${API_VERSION}/admin/movies/${query}`, payload)
    },
    GetMovieDetails(payload) {
        return Api().get(`/admin/movie/${payload.movie_code}`, payload)
       // return Api().get(`/${API_VERSION}/admin/movies/${payload.movie_code}`, payload)
    },
    AddMovieDetails(payload) {
        return Api().post(`/admin/movie/`, payload)
       // return Api().post(`/${API_VERSION}/admin/movies/${payload.movie_code}`, payload)
    },
    EditMovieDetails(payload) {
        return Api().put(`/admin/movie/${payload.movie_code}`, payload)
       // return Api().put(`/${API_VERSION}/admin/movies/${payload.movie_code}`, payload)
    },
    GetMovieLanguages() {
        return Api().get(`/admin/movie/languages`)
    },
    GetMovieGenres() {
        return Api().get(`/admin/movie/genres`)
    },
    GetMovieFormats() {
        return Api().get(`/admin/movie/formats`)
    },
    GetCensorRatings() {
        return Api().get(`/admin/movie/censorRatings`)
    },
    GetMovieRating(){
        return Api().get(`/admin/get-rating-movie`)

    },
       UpdateMovieRating(id, data){
        return Api().post(`/admin/rating-movie/${id}`,data)

    },
      GetSingleMovieRating(id){
        return Api().get(`/admin/getsingle-rating-movie/${id}`)
   
      },
      AddMovieRating(payload){
        return Api().post(`/admin/add-rating-movie`,payload)

    },

}
